import { OrderItem, OrderItemAccessoriesInfo } from '@leid/api-orders'

export const groupAccessoryOrderItems = (accessories: OrderItem[]): OrderItemAccessoriesInfo[] => {
  const requestAccessories = accessories.reduce((result: OrderItemAccessoriesInfo[], item: OrderItem) => {
    const productId = item.productId ?? 0

    const existing = result.find((s) => s.productId === productId)
    if (!existing) {
      result.push({
        amount: item.amount,
        productId: productId,
        orderItemId: item.id,
      })
    } else {
      existing.amount += item.amount
    }

    return result
  }, [])

  return requestAccessories
}
